import React from 'react'

import styles from '../VictionProject.module.scss'
import images from 'assets/images'
import BoxContent from 'components/BoxContent'
import ItemProject from 'components/ItemProject'
import { Link } from 'react-router-dom'
import useResizeWidth from 'controller/useResizeWidth'

const arrInfo = [
  {
    title: 'True Ownership',
    content: `Viction's blockchain infrastructure grants gamers real ownership of in-game assets, providing confidence in buying, selling, and trading virtual items through blockchain security.`,
    image: images.bannerGaming1,
  },
  {
    title: 'Enhanced Security',
    content: `Viction offers robust security features that protect both players and developers from fraud, hacks, and data breaches, ensuring a safe and secure gaming environment.`,
    image: images.bannerSolution,
  },
  {
    title: 'Scalability',
    content: `With Viction's scalable architecture, gaming ventures can accommodate a growing user base without sacrificing performance, ensuring that games run smoothly even as they attract more players.`,
    image: images.bannerGaming2,
    isVertical: true,
  },
  {
    title: 'Immersive Experience',
    content: `Viction's technology enables the creation of immersive gaming experiences by facilitating seamless in-game transactions, and unique gameplay elements.`,
    image: images.bannerGaming3,
    isVertical: true,
  },
]

const arrProject = [
  {
    title: 'Tezuka',
    icon: images.logoExample,
  },
  {
    title: 'BTSE',
    icon: images.logoExample2,
  },
  {
    title: 'TomoStats',
    icon: images.logoExample3,
  },
  {
    title: 'ThreeFold',
    icon: images.logoExample,
  },
  {
    title: 'API3',
    icon: images.logoExample2,
  },
  {
    title: 'TomoStats',
    icon: images.logoExample3,
  },
  {
    title: 'ThreeFold',
    icon: images.logoExample,
  },
]

function GamingScreen() {
  const { widthResize } = useResizeWidth()

  return (
    <div className={styles.victionProjectWrapper}>
      <div className='defi-banner-wrapper'>
        <div className='defi-banner-head'>
          <h1 className='head-title head-title--game'>
            Shape Gaming Experiences That Fuel Human Creativity
          </h1>

          <div className='head-link'>
            <div className='link-wrapper'>
              <Link
                target='_blank'
                to='https://docs.viction.xyz/'
                className='item-link text-base text-hover-underline'
              >
                Get Started
              </Link>
              <Link
                to='/community-hub'
                className='item-link text-base text-hover-underline'
              >
                Join Dev Community
              </Link>
            </div>
          </div>
        </div>

        <div className='defi-banner-img w-36'>
          <img src={images.bannerGaming} alt='' className='banner-img' />

          <div className='text-description text-lg'>
            Gaming is your innovation canvas, and we're the brush for your
            interactive future. Our solutions amplify your creativity, providing
            tools and support to bring your gaming dreams to life.
          </div>
        </div>
      </div>

      {/* <div className='project-list'>
        <h2 className='project-title'>Projects on Viction</h2>

        <div className='project-body w-18'>
          {arrProject.map((item, i) => {
            return <ItemProject item={item} type='small' key={i} />
          })}
        </div>

        <div className='project-description w-36'>
          <div className='description-text text-sm'>
            This information, provided by third-party projects, is for general
            information only. <br /> Viction doesn't guarantee its accuracy, nor
            should it imply endorsement or affiliation.
          </div>
        </div>
      </div> */}

      <BoxContent
        title={
          widthResize >= 1280
            ? `Why Choose Viction <br/> for Your Gaming Ventures?`
            : `Why Choose Viction for Your Gaming Ventures?`
        }
        arrData={arrInfo}
        className='game-content'
      />

      <div className='footer-page footer-page--gaming'>
        <div className='footer-container'>
          <div className='text-content text-content--text-1'>Built</div>
          <div className='text-content text-content--text-2'>on</div>
          <div className='text-content text-content--text-3'>Viction</div>

          <div className='footer-menu'>
            <Link
              target='_blank'
              to='https://docs.viction.xyz/'
              className='item-menu text-base text-hover-underline-white'
            >
              Get Started
            </Link>
            <Link
              to='/community-hub'
              className='item-menu text-base text-hover-underline-white'
            >
              Join Dev Community
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GamingScreen
